import { defineMessages } from 'react-intl';

export default defineMessages({
    policyInformation: {
        id: 'quoteandbind.ho.views.policy-info.Policy Info',
        defaultMessage: 'Policy Information'
    }, 
    policySummary: {
        id: 'quoteandbind.ho.views.policy-summary.Policy Summary',
        defaultMessage: 'Policy Summary'
    },
    coverageStartDate: {
        id: 'quoteandbind.ho.views.policy-info.Coverage Start Date',
        defaultMessage: 'Coverage Start Date'
    },
    primaryInsured: {
        id: 'quoteandbind.ho.views.policy-info.Primary Insured',
        defaultMessage: 'Primary Insured'
    },
    address: {
        id: 'quoteandbind.ho.views.policy-info.Address',
        defaultMessage: 'Address'
    },
    sameBillingAddress: {
        id: 'quoteandbind.ho.views.policy-info.Is the Billing Address the same as the above address?',
        defaultMessage: 'Is the Billing Address the same as the above address?'
    },
    email: {
        id: 'quoteandbind.ho.views.policy-info.Email',
        defaultMessage: 'Email'
    },
    phone: {
        id: 'quoteandbind.ho.views.policy-info.Phone',
        defaultMessage: 'Phone'
    },
    coverages: {
        id: 'quoteandbind.ho.views.policy-info.Your Coverages',
        defaultMessage: 'Coverages'
    },
    details: {
        id: 'quoteandbind.ho.views.policy-info.Details',
        defaultMessage: 'Details'
    },
    completeAndIssue: {
        id: 'quoteandbind.ho.views.policy-info.Complete and Issue',
        defaultMessage: 'Complete and Issue'
    },
    priorCarrierName:{
        id: 'quoteandbind.common.policy-info.Prior Carrier Name',
        defaultMessage: 'Prior Carrier Name'
    },
    priorPolicy:{
        id: 'quoteandbind.common.policy-info.Prior Policy #',
        defaultMessage: ' Prior Policy #'
    },
    priorExpirationDate:{
        id: 'quoteandbind.common.policy-info.Prior Expiration Date',
        defaultMessage: 'Prior Expiration Date'
    },
     downloadHOQuoteSummary:{
        id: 'quoteandbind.ho.policy-info.Download Quote Summary',
        defaultMessage: 'Download Quote Summary'
    },
    hoDocumentGenerationInProgress:{
       id: 'quoteandbind.ho.policy-info.Document Generation Is In Progress',
       defaultMessage: 'Document Generation Is In Progress'
    },
    hoDocumentGenerationInProgressConf:{
       id: 'quoteandbind.ho.policy-info.Document Generation Is In Progress. Please Try After Sometime.',
       defaultMessage: 'Document Generation Is In Progress. Please Try After Sometime.'
    },
    hoDocumentGenerationError:{
       id: 'quoteandbind.ho.policy-info.Unable to get quote document',
       defaultMessage: 'Unable to get quote document'
    },
    hoDocumentGenerationErrorConf:{
       id: 'quoteandbind.ho.policy-info.Problem occured while getting quote document. Please try again later',
       defaultMessage: 'Problem occured while getting quote document. Please try again later'
    },
    
});
